import clsx from 'clsx';
import Link from 'next/link';
import {
  PhonicsLesson,
  PhonicsLessonGroup,
  PhonicsStudentStatus,
} from '@/api/types';
import { Routes } from '@/routes';

interface BreadcrumbLinkProps {
  href: string;
}

const BreadcrumbLink = ({
  children,
  href,
}: React.PropsWithChildren<BreadcrumbLinkProps>) => (
  <Link className="underline hover:no-underline" href={href}>
    {children}
  </Link>
);

const getSectionLink = (
  section: ManageBreadcrumbProps['section'],
  isEnd = false,
) => {
  switch (section) {
    case 'dashboard':
      return isEnd ? (
        <>Dashboard</>
      ) : (
        <BreadcrumbLink href={Routes.PHONICS_MANAGE.path}>
          Dashboard
        </BreadcrumbLink>
      );
    case 'lessons':
      return isEnd ? (
        <>Lessons</>
      ) : (
        <BreadcrumbLink href={Routes.PHONICS_MANAGE_LESSONS.path}>
          Lessons
        </BreadcrumbLink>
      );
    case 'students':
      return isEnd ? (
        <>Students</>
      ) : (
        <BreadcrumbLink href={Routes.PHONICS_MANAGE_STUDENTS.path}>
          Students
        </BreadcrumbLink>
      );
    case 'decodable-books':
      return isEnd ? (
        <>Decodable Books</>
      ) : (
        <BreadcrumbLink href={Routes.PHONICS_MANAGE_LESSONS.path}>
          Decodable Books
        </BreadcrumbLink>
      );
    case 'assessment':
      return (
        <BreadcrumbLink href={Routes.PHONICS_MANAGE_LESSONS.path}>
          Assessment
        </BreadcrumbLink>
      );
    case 'training':
      return (
        <BreadcrumbLink href={Routes.PHONICS_MANAGE_LESSONS.path}>
          Teacher Training
        </BreadcrumbLink>
      );
  }
};

interface ManageBreadcrumbProps {
  className?: string;
  section:
    | 'dashboard'
    | 'lessons'
    | 'students'
    | 'decodable-books'
    | 'assessment'
    | 'training';
  yearGroup?: PhonicsLessonGroup;
  weekGroup?: PhonicsLessonGroup;
  lesson?: PhonicsLesson;
  student?: PhonicsStudentStatus;
  suffix?: React.ReactNode;
}

export const ManageBreadcrumb = ({
  className,
  section,
  yearGroup,
  weekGroup,
  lesson,
  student,
  suffix,
}: ManageBreadcrumbProps) => (
  <div className={clsx('text-sm text-pt-primary dark:text-white', className)}>
    <BreadcrumbLink href={`/`}>Pickatale Phonics</BreadcrumbLink> -{' '}
    {getSectionLink(section)} {yearGroup && `- ${yearGroup.name}`}{' '}
    {weekGroup && `- ${weekGroup.name}`} {lesson && `- Lesson ${lesson.number}`}
    {student && `- ${student.name}`}
    {suffix && <>- {suffix}</>}
  </div>
);
